<div class="notification notification--{{notification.type}}" [ngClass]="{'notification--active':notification.active}">
    <span class="notification__icon glyphicons"></span>
    <div class="notification__textContainer">
        <p class="notification__text">{{ notification.message }}</p>
    </div>
</div>